import React, { useState, useEffect } from 'react';
import logoImgFile from '../assets/yii_page-0002.png'; 

// مكون الملفات مدمج ليكون جزءاً من الهيدر
const PortfolioDropdown = ({ lang, isRtl, isMobile = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const files = [
    { 
      id: 1, 
      label: isRtl ? 'بروفايل الشركة' : 'Company Profile', 
      url: 'https://www.yam-ii.com/yam_api/uploads/Company Profile Yam International Industries.pdf', 
      icon: '🏢' 
    },
    { 
      id: 2, 
      label: isRtl ? ' كتالوج منتجات المنظفات' : 'Detergent Product Catalogue', 
      url: 'https://www.yam-ii.com/yam_api/uploads/products.pdf', 
      icon: '📦' 
    },
    { 
      id: 3, 
      label: isRtl ? 'كتالوج منتجات العناية بالسيارات' : 'Car Care Products Catalogue', 
      url: 'https://www.yam-ii.com/yam_api/uploads/cplus.pdf', 
      icon: '➕' 
    },
  ];

  // تنسيق خاص للموبايل داخل القائمة الجانبية
  if (isMobile) {
    return (
      <div className="mobile-portfolio-wrapper" style={{ width: '100%', textAlign: 'center' }}>
        <button 
          className="mobile-link" 
          onClick={() => setIsOpen(!isOpen)}
          style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', width: '100%' }}
        >
          {isRtl ? '📁 الملفات' : '📁 Files'} {isOpen ? '−' : '+'}
        </button>
        {isOpen && (
          <div className="mobile-portfolio-sub" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px 0' }}>
            {files.map((file) => (
              <a key={file.id} href={file.url} target="_blank" rel="noreferrer" className="mobile-link" style={{ fontSize: '1rem', opacity: 0.8 }}>
                {file.icon} {file.label}
              </a>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="header-portfolio-wrapper" style={{ position: 'relative' }}>
      <button 
        className={`header-portfolio-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="portfolio-btn-icon">{isOpen ? '✕' : '📄'}</span>
        <span className="portfolio-btn-text">{isRtl ? 'الملفات' : 'Files'}</span>
      </button>

      <div className={`header-portfolio-menu ${isOpen ? 'open' : ''}`} 
           style={{ right: isRtl ? 'auto' : '0', left: isRtl ? '0' : 'auto' }}>
        {files.map((file) => (
          <a key={file.id} href={file.url} target="_blank" rel="noreferrer" className="header-portfolio-item">
            <span className="item-icon">{file.icon}</span>
            <span className="item-label">{file.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

const Header = ({ lang, setLang, t }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(window.scrollY > 50); 
  const isRtl = lang === 'ar';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    handleScroll(); 
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lang]);

  const handleHomeClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 70;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="super-header-wrapper" style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      
      <div className={`top-bar ${scrolled ? 'hide-top-bar' : 'is-transparent'}`}>
        <div className="container-limited top-bar-flex" style={{ justifyContent: 'flex-end' }}>
          <div className="contact-info">
            <a href="tel:01070703878" className="top-link-item" style={{ direction: 'ltr' }}>
                <span className="icon-badge">📱</span>
                <span className="always-visible-text">01070703878</span>
            </a>
            <a href="tel:0228590490" className="top-link-item" style={{ direction: 'ltr' }}>
                <span className="icon-badge">📞</span>
                <span className="always-visible-text">02 28590490</span>
            </a>
            <a href="mailto:info@yam-ii.com" className="top-link-item" style={{ direction: 'ltr' }}>
                <span className="icon-badge">✉️</span>
                <span className="always-visible-text">info@yam-ii.com</span>
            </a>
          </div>
        </div>  
      </div>

      <header className={`main-nav ${scrolled ? 'nav-scrolled' : 'nav-transparent'}`}>
        <div className="container-limited nav-flex">
          <a href="#home" onClick={handleHomeClick} className="logo-area">
            <div className="logo-img-wrapper">
              <img src={logoImgFile} alt="YAM Logo" className="logo-img" />
            </div>
            <div className="logo-text-box">
              <h2 className="logo-title">
                <span className="brand-name">{lang === 'ar' ? 'يام انترناشونال ' : 'YAM INTERNATIONAL '}</span>
                <span className="gold-text brand-sub">{lang === 'ar' ? 'للصناعات' : 'INDUSTRIES'}</span>
              </h2>
            </div>
          </a>

          <nav className="desktop-links">
            <a href="#home" onClick={handleHomeClick}>{t.nav.home}</a>
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>{t.nav.about}</a>
            <a href="#our-story" onClick={(e) => scrollToSection(e, 'our-story')}>{isRtl ? 'قصتنا' : 'Our Story'}</a>
            <a href="#brands" onClick={(e) => scrollToSection(e, 'brands')}>{isRtl ? 'المنتجات ' : 'Products'}</a>
            <a href="#projects" onClick={(e) => scrollToSection(e, 'projects')}>{isRtl ? 'الأخبار' : 'News'}</a>
            <a href="#export" onClick={(e) => scrollToSection(e, 'export')}>{isRtl ? 'حضور عالمي' : 'Global Presence'}</a>
            <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>{isRtl ? 'اتصل بنا' : 'Contact'}</a>

            <a href="#yamshop" className="shop-btn-link" onClick={(e) => scrollToSection(e, 'yamshop')}>
              {isRtl ? 'المتجر' : 'Store'}
            </a>

            {/* الملفات للديسكتوب */}
            <PortfolioDropdown lang={lang} isRtl={isRtl} />
            
            <button className="lang-toggle-btn" onClick={() => setLang(isRtl ? 'en' : 'ar')}>
              {isRtl ? 'EN' : 'AR'}
            </button>
          </nav>

          <button className={`hamburger ${isMenuOpen ? 'is-active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </button>
        </div>

        <div className={`mobile-overlay ${isMenuOpen ? 'menu-open' : ''}`}>
          <div className="mobile-links-container">
            <a href="#home" className="mobile-link" onClick={handleHomeClick}>{t.nav.home}</a>
            <a href="#about" className="mobile-link" onClick={(e) => scrollToSection(e, 'about')}>{t.nav.about}</a>
            <a href="#our-story" className="mobile-link" onClick={(e) => scrollToSection(e, 'our-story')}>{isRtl ? 'قصتنا' : 'Story'}</a>
            <a href="#brands" className="mobile-link" onClick={(e) => scrollToSection(e, 'brands')}>{isRtl ? 'المنتجات' : 'Products'}</a>
            
            {/* تم إضافة الملفات هنا للموبايل لتظهر داخل القائمة */}
            <PortfolioDropdown lang={lang} isRtl={isRtl} isMobile={true} />

            <a href="#projects" className="mobile-link" onClick={(e) => scrollToSection(e, 'projects')}>{isRtl ? 'الأخبار' : 'News'}</a>
            <a href="#export" className="mobile-link" onClick={(e) => scrollToSection(e, 'export')}>{isRtl ? 'حضور عالمي' : 'Global Presence'}</a>
            <a href="#contact" className="mobile-link" onClick={(e) => scrollToSection(e, 'contact')}>{isRtl ? 'اتصل بنا' : 'Contact'}</a>

            <a href="#yamshop" className="mobile-link mobile-shop-btn" onClick={(e) => scrollToSection(e, 'yamshop')}>
              {isRtl ? 'متجر يام' : 'Yam Store'}
            </a>
            
            <button className="mobile-lang-btn" onClick={() => {setLang(isRtl ? 'en' : 'ar'); setIsMenuOpen(false);}}>
              {isRtl ? 'English' : 'العربية'}
            </button>
          </div>
        </div>
      </header>

      <style>{`
        .super-header-wrapper { position: fixed; top: 0; left: 0; width: 100%; z-index: 9999; transition: all 0.3s ease; }
        .nav-transparent { background: transparent !important; box-shadow: none !important; }
        .top-bar.is-transparent { background: rgba(13, 31, 51, 0.4) !important; border-bottom: 1px solid rgba(255,255,255,0.1); }
        .nav-scrolled { background: #1a3a5a !important; box-shadow: 0 4px 15px rgba(0,0,0,0.2) !important; padding: 5px 0; }
        .container-limited { width: 95%; max-width: 1400px; margin: 0 auto; display: flex; align-items: center; }
        .top-bar { background: #0d1f33; color: #d4af37; transition: 0.4s; overflow: hidden; max-height: 150px; }
        .hide-top-bar { max-height: 0; opacity: 0; }
        .top-bar-flex { justify-content: space-between; align-items: center; padding: 6px 0; flex-wrap: wrap; gap: 8px; }
        .contact-info { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
        .top-link-item { color: #d4af37; text-decoration: none; display: flex; align-items: center; gap: 4px; direction: ltr !important; }
        .always-visible-text { font-size: clamp(0.65rem, 0.8vw, 0.85rem); white-space: nowrap; font-weight: 600; }
        .main-nav { transition: all 0.4s ease; width: 100%; }
        .nav-flex { justify-content: space-between; align-items: center; padding: 15px 0; gap: 10px; }
        .logo-area { display: flex; align-items: center; gap: 8px; text-decoration: none; flex-shrink: 0; }
        .logo-img { height: clamp(45px, 5.5vw, 65px); width: auto; filter: brightness(0) invert(1); transition: transform 0.3s ease; }
        .logo-area:hover .logo-img { transform: scale(1.1); }
        .brand-name { color: white; font-weight: 800; font-size: clamp(0.8rem, 1.2vw, 1.2rem); text-shadow: 0 2px 4px rgba(0,0,0,0.3); white-space: nowrap; }
        .gold-text { color: #d4af37; font-weight: 600; font-size: clamp(0.6rem, 0.9vw, 0.9rem); }
        .desktop-links { display: flex; gap: clamp(8px, 1.3vw, 22px); align-items: center; }
        .desktop-links a { color: white; text-decoration: none; font-size: clamp(0.75rem, 0.9vw, 1rem); font-weight: 700; text-shadow: 0 2px 4px rgba(0,0,0,0.5); transition: 0.3s; white-space: nowrap; }
        .shop-btn-link { background: #d4af37; color: #1a3a5a !important; padding: 8px clamp(12px, 1.5vw, 20px); border-radius: 25px; font-weight: 800; font-size: clamp(0.75rem, 0.9vw, 1rem); }
        
        /* تنسيقات Portfolio */
        .header-portfolio-btn { 
          background: rgba(212, 175, 55, 0.1); border: 1px solid #d4af37; color: #d4af37; 
          padding: 8px 15px; border-radius: 25px; font-weight: 800; 
          font-size: clamp(0.75rem, 0.9vw, 1rem); display: flex; align-items: center; gap: 6px; 
          cursor: pointer; transition: 0.3s;
        }
        .header-portfolio-btn:hover, .header-portfolio-btn.active { background: #d4af37; color: #1a3a5a; }
        .header-portfolio-menu { 
          position: absolute; top: calc(100% + 15px); background: #0d1f33; 
          border: 1px solid rgba(212, 175, 55, 0.3); border-radius: 12px; 
          min-width: 200px; box-shadow: 0 10px 30px rgba(0,0,0,0.5); 
          opacity: 0; transform: translateY(-10px); pointer-events: none; transition: 0.3s; padding: 8px; z-index: 10000;
        }
        .header-portfolio-menu.open { opacity: 1; transform: translateY(0); pointer-events: all; }
        .header-portfolio-item { 
          display: flex; align-items: center; gap: 10px; padding: 10px 15px; 
          color: white; text-decoration: none; font-size: 13px; font-weight: 600; 
          border-radius: 8px; transition: 0.2s;
        }
        .header-portfolio-item:hover { background: rgba(212, 175, 55, 0.2); color: #d4af37; }

        .hamburger { display: none; flex-direction: column; gap: 4px; background: none; border: none; }
        .line { width: 25px; height: 3px; background: #d4af37; }
        @media (max-width: 1300px) { .nav-flex { gap: 8px; } .desktop-links { gap: 10px; } }
        @media (max-width: 1100px) { .desktop-links { display: none; } .hamburger { display: flex; } }
        .mobile-overlay { position: fixed; top: 0; right: -110%; width: 100%; height: 100vh; background: #0d1f33; transition: 0.4s; display: flex; justify-content: center; align-items: center; z-index: 10000; }
        .menu-open { right: 0; }
        .mobile-links-container { display: flex; flex-direction: column; gap: 20px; align-items: center; }
        .mobile-link { color: white; text-decoration: none; font-size: clamp(1.1rem, 4vw, 1.5rem); font-weight: 700; }
      `}</style>
    </div>
  );
};

export default Header;